export const getTimeWindow = (location) => {
  let timeWindow = "";

  if (location.arrival_time) {
    timeWindow = location.arrival_time;
  }
  if (location.finish_time) {
    timeWindow = location.finish_time;
  }
  if (location.arrival_time && location.finish_time) {
    timeWindow = `${location.arrival_time} - ${location.finish_time}`;
  }

  return timeWindow;
};



// WEBPACK FOOTER //
// ./src/helpers/location.js